import api from './apiHelper';
import { queryCache } from 'react-query';
import { useCustomQuery } from 'hooks/reactQuery';

export const useGetValues = () => {
  const getValueStores = async () => {
    return api.get(`/valuestore/`);
  };
  return useCustomQuery('valuestore', [], getValueStores);
};

export const patchValues = payload => {
  return api.patch(`/valuestore/`, payload);
};

export const refetchValues = () => {
  queryCache.refetchQueries(['valuestore']);
};
